import React, { Component } from 'react';
import { Image, Button } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import TransactionModuleBase from './TransactionModuleBase';

import { ajaxPost } from '../../ajax';
import ViewNotificationDetails from './Commons/ViewNotificationDetails';
import ChangeScheduleForm from './Forms/ChangeScheduleForm';
import { ajaxPostDownload, isTaskAvailable, checkDate, checkTime, checkInt32, momentDateFormat } from '../../utils';
import MessageBoxOkOnly from '../../Commons/MessageBoxOkOnly';
import { SelectColumn } from 'react-data-grid';

var ViewID = "ChangeSchedule";
var ViewCaption = "Change Schedule";

const moment = require('moment');
const updateStatus = "api/ChangeSchedule/updateStatus";
// const { Editors: { DropDownEditor } } = require('react-data-grid');
// const applicationStatuses = [
// 	'PENDING',
// 	'APPROVED',
// 	'CANCELLED',
// 	'REJECTED'
// ];
const userRightsKeys = {
	view: "CHANGE_SCHEDULE_VIEW",
	create: "CHANGE_SCHEDULE_CREATE",
	edit: "CHANGE_SCHEDULE_EDIT",
	delete: "CHANGE_SCHEDULE_DELETE",
	restore: "CHANGE_SCHEDULE_RESTORE",
	approve: "CHANGE_SCHEDULE_APPROVE",
	reject: "CHANGE_SCHEDULE_REJECT",
	pend: "CHANGE_SCHEDULE_PEND",
	cancel: "CHANGE_SCHEDULE_CANCEL",
	export: "CHANGE_SCHEDULE_EXPORT_TO_EXCEL",
	import: "CHANGE_SCHEDULE_IMPORT"
};

class ChangeScheduleList extends Component {

	constructor(props) {
		super(props);
		this.state = {
			modalVisible: false,
			fromDate: moment().format(props.startDate),
			toDate: moment().format(props.endDate),
		}
		this.modalRef = React.createRef();
		this.parentRef = React.createRef();
	}

	createUrls = () => {
		return {
			getStatusCounts: "api/ChangeSchedule/getStatusCounts",
			search: "api/ChangeSchedule/search",
			setDeleted: "api/ChangeSchedule/setDeleted",
			saveMultiple: "api/ChangeSchedule/saveMultiple",
			save: "api/ChangeSchedule/save",
			load: "api/ChangeSchedule/load",
			searchEmployees: "api/ChangeSchedule/searchEmployees",
			updateStatus: updateStatus,
			exportToExcel: "api/ChangeSchedule/exportToExcel",
			downloadTemplate: "api/ChangeSchedule/downloadTemplate",
			importFromExcel: "api/ChangeSchedule/importFromExcel"
		};
	}

	toRow = (model) => {
		return {
			id: model._id,
			employeeId: model.EmployeeId,
			deleted: this.isNullOrEmpty(model.IsDeleted) ? false : model.IsDeleted,
			employee: model.Employee,
			date: moment(model.Date).format(momentDateFormat),
			startTime: moment(model.StartTime).format("hh:mm A"),
			hours: (model.Minutes / 60).toFixed(2),
			breakStart: !this.isNullOrEmpty(model.BreakStart) ? moment(model.BreakStart).format("hh:mm A") : "",
			hoursBreak: (model.MinutesBreak / 60).toFixed(2),
			restDay: model.RestDay ? "YES" : "NO",
			status: model.Status,
			remarks: model.Remarks,
			approver: model.Approver,
			approverId: model.ApproverId,
			approverRemarks: model.ApproverRemarks,
			changeStatusDate: !model.ChangeStatusDate ? "" : moment(model.ChangeStatusDate).format(momentDateFormat),
			requestDate: moment(model.RequestDate).format(momentDateFormat),
			file:model.AttachmentDetail != null ? model.AttachmentDetail.File : "",
			actions:model.AttachmentDetail != null && model.AttachmentDetail.File !== "" && model.AttachmentDetail.File != null ?                                               
			<div style={{display:'flex', width:'100%', height:'100%', justifyContent:'center', alignItems:'center' }}><Button 
				style={{fontSize: '0.8rem'}}
				icon="download"
				circular
				onClick={this.downloadDoc.bind(
					this,
					model.AttachmentDetail.UniqueFilename,
					model.AttachmentDetail.File
				  )}
			/> </div>: "",
			AttachmentDetail: model.AttachmentDetail,
			editable: false,
			idle: false
		};
	};
	
	downloadDoc(filename, origName) {
        var api = "api/TransactionsCommon/download?" +
            "fileName=" +
            filename +
            "&" +
            "originalName=" +
            origName;
		ajaxPostDownload(
			api,
			{},
			origName,
			(data, sender) => {
				this.setState({ exportLoading: false });
			},
			(error) => {
				alert("Error:\r\n" + JSON.stringify(error));
			},
			() => {
				this.setState({ exportLoading: false });
			}

		) 
    }

	toModel = (row) => {
		let minutes = row.hours * 60;
		minutes -= minutes % 1;
		let minutesBreak = row.hoursBreak * 60;
		minutesBreak -= minutesBreak % 1;
		return {
			_id: row.id,
			EmployeeId: row.employeeId,
			Date: moment(row.date).toJSON(),
			StartTime: moment(row.date + " " + row.startTime).toJSON(),
			Minutes: minutes,
			BreakStart: row.breakStart !== null || row.breakStart !== undefined ? moment(row.date + " " + row.breakStart).toJSON() : null,
			MinutesBreak: minutesBreak,
			RestDay: row.restDay === "YES" ? true : false,
			Status: row.status,
			File: row.file,
			AttachmentDetail: row.AttachmentDetail,
			Remarks: row.remarks
		};
	};

	createColumns = () => {
		// var self = this;
		// let hasHrAccess = isTaskAvailable("HR_ROLE");
		let columns = [
			SelectColumn,
			{ key: 'date', name: 'Date', width: 90, resizable: true},
			{ key: 'startTime', name: 'Start Time', width: 100, resizable: true},
			{ key: 'hours', name: 'Hours', width: 70, resizable: true},
			{ key: 'hoursBreak', name: 'Break Hrs.', width: 80, resizable: true},
			{ key: 'breakStart', name: 'Break Start', width: 80, resizable: true},
			{ key: 'restDay', name: 'Rest Day', width: 90, resizable: true},
			{ key: 'status', name: 'Status', width: 90, resizable: true},
			{ key: 'remarks', name: 'Reasons', width: 150, resizable: true},
			{ key: 'changeStatusDate', name: 'Change Status Date', width: 130, resizable: true },
			{ key: 'approver', name: 'Approver', width: 220, resizable: true },
			{ key: 'approverRemarks', name: 'Approver Remarks', width: 150, resizable: true },
			{ key: 'requestDate', name: 'Date Filed', width: 90, resizable: true },
			{ key: 'file', name: 'File', width: 100, resizable: true },
			{ key: 'actions', name: 'Actions', width: 90, resizable: true },
		];
		// if(this.state.viewType == "hr"){
		columns.unshift({
			key: 'employee', name: 'Employee', width: 220, resizable: true
		});
		// }

		return columns;
	}

	validate = (data) => {
		var errTitle = "", errCaption = "";
		var checkDateParam = checkDate(data.Date);
		var checkTimeParam = checkTime(data.StartTime);
		var checkInt32MinutesParam = checkInt32(data.Minutes, false)
		var checkInt32MinutesBreakParam = checkInt32(data.MinutesBreak, false)
		// if (this.isNullOrEmpty(data.employeeIds)) {
		//     errTitle="Invalid"
		//     errCaption="Select an employee first."
		// }
		if (this.isNullOrEmpty(data.employeeIds) ||
			this.isNullOrEmpty(data.Remarks)
		) {
			errCaption = "Please fill up all required field/s";
			errTitle = "Invalid";
		}
		else if (!checkDateParam.Result) {
			errCaption = checkDateParam.Message;
			errTitle = checkDateParam.Title;
		}
		else if (!checkTimeParam.Result) {
			errCaption = checkTimeParam.Message;
			errTitle = checkTimeParam.Title;
		}
		else if (!checkInt32MinutesParam.Result) {
			errCaption = checkInt32MinutesParam.Message;
			errTitle = checkInt32MinutesParam.Title;
		}
		else if (!checkInt32MinutesBreakParam.Result) {
			errCaption = checkInt32MinutesBreakParam.Message;
			errTitle = checkInt32MinutesBreakParam.Title;
		} else if (data.Minutes <= 0 || data.Minutes <= data.MinutesBreak) {
			errCaption = "Invalid hours/hours break";
			errTitle = "Invalid";
		}
		else {
			this.parentRef.current.setState({ showRequiredField: false });
			return true;
		}
		this.parentRef.current.setState({ showRequiredField: true, errTitle, errCaption });
		return false;
	};

	showModal = (data, visible) => {
		visible && this.modalRef.current.setContent(data);
		this.setState({ modalVisible: visible });
	}

	isNullOrEmpty(val) {
		if (val === null || val === undefined || val === "" || val.length === 0) return true;
		else return false;
	}

	render() {
		let self = this;
		return (
			<TransactionModuleBase
				ref={this.parentRef}
				startDate={this.state.fromDate}
				endDate={this.state.toDate}
				module="Change Schedules"
				viewID={ViewID}
				title={ViewCaption}
				columns={this.createColumns()}
				toModel={this.toModel}
				toRow={this.toRow}
				urls={this.createUrls()}
				validate={this.validate}
				props={this.props}
				showModal={this.showModal.bind(this)}
				userRightsKeys={userRightsKeys}
				hasExportToExcel={true}
			>
					<ChangeScheduleForm
						ref={this.modalRef}
						open={this.state.modalVisible}
						errTitle={self.parentRef.current ? self.parentRef.current.state.errTitle : ""}
						errCaption={self.parentRef.current ? self.parentRef.current.state.errCaption : ""}
						showRequiredField={self.parentRef.current ? self.parentRef.current.state.showRequiredField : ""}
						updateEmployeeIds={(Ids) => { self.parentRef.current.updateEmployeeIds(Ids) }}
						isBusy={self.parentRef.current ? self.parentRef.current.state.isSaving : false}
						onCancel={() => { 
							this.setState({ modalVisible: false }, self.parentRef.current.setState({ showRequiredField: false })); 
						}}
						onCreateEmpClick={() => {
							this.setState({ modalVisible: false });
							this.props.createEmpCallback();
						}}
						onSave={() => {
							if (self.modalRef.current.state._id) {
								self.parentRef.current.editFromModal(
									self.modalRef.current.getContent()
								)
							}
							else {
								self.parentRef.current.saveFromModal(
									self.modalRef.current.getContent()
								);
							}
						}}
					>
					</ChangeScheduleForm>
			</TransactionModuleBase>
		);
	}

}

ChangeScheduleList.getViewID = () => { return ViewID };
ChangeScheduleList.getCaption = () => { return ViewCaption }
ChangeScheduleList.getIcon = () => { return (<Image style={{ "height": "24px", "width": "24px" }} src='/Icons/Change_Schedule.png' avatar />); }
ChangeScheduleList.getIconSrc = (size) => { return '/Icons/Change_Schedule.png' }
ChangeScheduleList.getViewAccessKey = function () {
	var count = Object.keys(userRightsKeys).filter(name => isTaskAvailable(userRightsKeys[name]) === true).length;
	return count > 0 ? true : false;
};
ChangeScheduleList.init = function (parent) {
	var handleChangeScheduleAction = function (status, data, callback) {
		var message = "";
		var title = data.Title;
		if (status === "CLOSE") 
			parent.setState({ external: null })
		else {
			var items = [];
			items.push(data.Data);
			var dataItems = { items: items, status: status, remarks: data.Data.ApproverRemarks };
			dataItems.fromDate = moment(data.Data.Date).toJSON();
			dataItems.toDate = moment(data.Data.Date).toJSON();
			var parameter = {
				data: dataItems,
				url: updateStatus,
				onError: function (error) {
					alert("Error occured");
				},
				onSuccess: (data, sender) => {
					if (data[data.length - 1].hasOwnProperty("errMessage")) {
						let lastIndex = data.length - 1;
						let titleSingular = title.toLowerCase() === 'official businesses' ? title.substring(0, title.length - 2) : title.substring(0, title.length - 1);
						title = "Invalid";
						message = status === "APPROVED" ? "Already approved " + titleSingular.toLowerCase() + " request has been found." : data[lastIndex]["errMessage"];
					}
					else {
						message = data[0].Message || "Transaction status has been updated successfully.";
					}
					parent.setState({
						external:
							<MessageBoxOkOnly
								title={title || "Success"}
								caption={message}
								onClick={() => {
									parent.setState({ external: null });
								}}
							/>
					});
				},
				finally: function () {
					callback(message, status);
				}
			};
			ajaxPost(parameter);
		}
	};
	var notificationAction =
		function (parent, action, data, callback) {
			var status = "";
			switch (action.Action) {
				case "Approve": status = "APPROVED"; break;
				case "Reject": status = "REJECTED"; break;
				case "Cancel": status = "CANCELLED"; break;
				default: status = "View"; break;
			}

			//var actionTaken = data["ActionSelection"];
			if (data["ActionTaken"] === "NONE" && data["IsActionable"] === false) {
				data["ActionTaken"] = "READ";
				ajaxPost(
					{
						url: "api/Notification/markAsRead",
						data: data._id,
						onSuccess: data => { },
						finally: () => { }
					}
				)
			}

			ajaxPost({
				url: "api/Notification/loadDataOnly",
				data: data["_id"],
				onSuccess: x => {
					data["Data"] = x;
				},
				finally: () => {
					data["ActionTaken"] = data["ActionTaken"].toString() === "" ? "NONE" : data["ActionTaken"];
					if (status === "View") {
						var viewData = {
							"Date": moment(data.Data["Date"]).format(momentDateFormat),
							"Start Time": moment(data.Data["StartTime"]).format("hh:mm A"),
							"Rest Day": data.Data["RestDay"] ? "Yes" : "No",
							"Hours": (data.Data["Minutes"] / 60).toFixed(2),
							"Break Hours": (data.Data["MinutesBreak"] / 60).toFixed(2),
							"Status": data.Data["Status"],
							"Remarks": data.Data["Remarks"],
							"Description": data["Description"],
						};
						if (data.Data["ApproverRemarks"]) {
							viewData["Approver Remarks"] = data.Data["ApproverRemarks"];
						}
						parent.setState({ external: <ViewNotificationDetails Title={data.Title} data={data} viewData={viewData} callback={callback} onAction={this.handleChangeScheduleAction.bind(this)} /> });
					}
					else {
						data.Data["ApproverRemarks"] = "";
						this.handleChangeScheduleAction(status, data, callback);
					}
				}
			});
		}
	parent.FunctionCollection["changeScheduleNotification"] = notificationAction;
	parent.FunctionCollection["handleChangeScheduleAction"] = handleChangeScheduleAction;
}

export default ChangeScheduleList;